export default {
  computed: {
    output() {
      return this.caseOutputs.ALTERNATIVE_ANALYSIS;
    },
    simulationYearArray() {
      const size = this.inputCase.settings.year_end - this.inputCase.settings.year_start;
      const yearArray = Array(1).fill(this.inputCase.settings.year_start);
      for (let i = 0; i < size; i += 1) {
        yearArray[i + 1] = yearArray[i] + 1;
      }
      return yearArray;
    },
    // Installed By Fuel Type
    installedByFuelType() {
      const size = Object.keys(this.output.generators[0].installed_capacity).length;
      return Object.values(this.output.generators).reduce((acc, gen) => {
        const key = gen.source;
        if (!acc[key]) {
          acc[key] = Array(size).fill(0);
        }
        acc[key] = acc[key].map((val, year) => val + gen.installed_capacity[year]);
        return acc;
      }, {});
    },

    // Expansion & Retirements
    expensionsRetirements() {
      return Object.keys(this.installedByFuelType).reduce(
        (acc, type) => ({
          ...acc,
          [type]: this.installedByFuelType[type]
            .reduceRight((res, el, i, arr) => {
              return i === 0 ? res : res.concat(el - arr[i - 1]);
            }, [])
            .reverse(),
        }),
        {}
      );
    },

    // Renewable Share
    renewableShare() {
      const installedCapacity = this.getOutput("installed_capacity", this.output);
      const renewableInstalled = [
        this.installedByFuelType.SOLAR_PV,
        this.installedByFuelType.HYDRO,
        this.installedByFuelType.HYDRO_ROR,
        this.installedByFuelType.WIND,
      ];

      // Add individual generators marked as renewable in input (e.g., specific biomass units)
      const traditionalRenewableSources = ["SOLAR_PV", "HYDRO", "HYDRO_ROR", "WIND"];
      if (this.inputCase && this.inputCase.input.generators && this.output.generators) {
        this.output.generators.forEach((outputGen) => {
          if (traditionalRenewableSources.includes(outputGen.source)) {
            return; // Skip if already included by fuel type
          }
          const inputGen = this.inputCase.input.generators.find((g) => g.id === outputGen.id);
          if (inputGen && inputGen.count_as_renewable === true) {
            renewableInstalled.push(Object.values(outputGen.installed_capacity));
          }
        });
      }

      const renewableShare = renewableInstalled.reduce((acc, renewable) => {
        if (renewable) {
          renewable.forEach((el, index) => {
            acc[index] = (acc[index] || 0) + el;
          });
        }
        return acc;
      }, []);
      Object.values(installedCapacity).forEach((el, index) => {
        renewableShare[index] = (renewableShare[index] / el) * 100;
      });
      return renewableShare;
    },

    // Storage Installed Capacity
    storageInstalled() {
      return Object.values(this.output.storage).reduce((acc, obj) => {
        const key = obj.name;
        if (!acc[key]) {
          acc[key] = [];
        }
        acc[key] = Object.values(obj.installed_capacity);
        return acc;
      }, {});
    },

    // Storage Quick Look
    storageQuickLook() {
      const storageSum = Object.values(this.storageInstalled).reduce((acc, storage) => {
        storage.forEach((acc2, index) => {
          acc[index] = (acc[index] || 0) + acc2;
        });
        return acc;
      }, []);
      return storageSum;
    },

    // Simulation year
    horizon() {
      return Object.keys(this.output.peak_demand).length;
    },

    // Created Date
    date() {
      return this.inputCase.created.substring(0, this.inputCase.created.indexOf("T"));
    },

    // Created Time
    time() {
      return this.inputCase.created.substring(
        this.inputCase.created.indexOf("T") + 1,
        this.inputCase.created.indexOf(".")
      );
    },
  },

  methods: {
    getOutput(name, inout) {
      if (typeof name === "string") {
        return inout[name] || [];
      }
      if (typeof name === "function") {
        return name(inout);
      }
      throw Error(`Invalid output key ${name}`);
    },
    getOutputQuickLook(name, inout) {
      const out = this.getOutput(name, inout);
      return [out[0], out[Object.keys(out).length - 1]];
    },
    formatString(character) {
      // eslint-disable-next-line no-param-reassign
      character = character.replace(/_/g, " ");
      const separateWord = character.toLowerCase().split(" ");
      separateWord.forEach((el, index) => {
        separateWord[index] =
          separateWord[index].charAt(0).toUpperCase() + separateWord[index].substring(1);
      });
      return separateWord.join(" ");
    },
  },
};
